import Action from '@/gf/components/Action'
import UploadButton from '@/gf/components/UploadButton'
import Attachment from '@/gf/modules/Attachment'
import { cn } from '@/gf/modules/utils'
import useMsgs from '@/gf/hooks/useMsgs'
import { File } from 'lucide-react'
import { useState } from 'react'

const Upload = ({
  title = 'Upload Order',
  uploadContext = 'buyer_create_external_order',
  onStarted,
  onComplete,
}: {
  title?: string
  // Free-form label, recorded as upload telemetry only.
  uploadContext?: string
  onStarted: () => void
  // `previewUrl` is the authed URL to render the file with before the form is submitted
  // (GEA-4585). The server always sends one; submit `url`, never render it.
  onComplete: (url: string, previewUrl: string | null) => void
}) => {
  const [focus, setFocus] = useState(false)
  const [_, msgr] = useMsgs()
  const allowedFileTypes = Attachment.documentFileTypes

  const handleError = (error: string) => {
    msgr.add(error, 'negative')
  }

  return (
    <div className="space-y-4">
      <div className="text-xl">{title}</div>

      <div>
        <UploadButton
          allowedFileTypes={allowedFileTypes}
          onUploadStarted={onStarted}
          serverNamedKey
          onUploadComplete={(files) => onComplete(files[0].url, files[0].previewUrl ?? null)}
          onError={handleError}
          uploadContext={uploadContext}
        >
          <div
            className={cn(
              'p-4 flex gap-4 items-center rounded-lg border-2 border-gray-200 border-dashed bg-gray-50',
              focus && 'border-gearflow border-solid'
            )}
            onDragLeave={() => setFocus(false)}
            onDragOver={() => setFocus(true)}
            onDrop={() => setFocus(false)}
          >
            <Action.S className="flex gap-2 items-center whitespace-nowrap">
              <File className="w-5 h-5" /> Select File
            </Action.S>

            <span className="text-gray-500 font-medium">or drag & drop file here</span>
          </div>
        </UploadButton>
      </div>
    </div>
  )
}

export default Upload
